<div class="world-controller">
    <button (click)="onSpawnNpc()">Spawn NPC</button>
    <button (click)="onSpawnCop()">Spawn Cop</button>
</div>
